import React, { useContext, useState } from 'react';
import styled from 'styled-components';
import { Menu, Row, Col, Drawer, Button, Alert } from 'antd';
import TagLogo from '../tag-logo';
import { device } from '../../lib/theme';
import { useMedia } from '../../utils/hooks';
import { WithSearch, SearchBox } from '@elastic/react-search-ui';
import {
  TeamOutlined,
  SearchOutlined,
  PushpinOutlined,
  MenuOutlined,
} from '@ant-design/icons';
import { SettingContext } from '../../lib/context/settings';
import { menu, menuTMIC, menuUIC } from '../../data/menu';
import Modal from 'antd/lib/modal/Modal';

const PreHeader = styled.div`
  background-color: #343434;
  color: white;
  height: 50px;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: horizontal;
  -webkit-box-direction: normal;
  -ms-flex-flow: row;
  flex-flow: row;
  -webkit-box-pack: end;
  -ms-flex-pack: end;
  justify-content: flex-end;
  margin: 0;
`;

const PreHeaderNavigation = styled.ul`
  margin-bottom: 0;
  display: -webkit-inline-box;
  display: -ms-inline-flexbox;
  display: inline-flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  padding: 0;
  -webkit-transition: 0.3s all ease-in-out;
  transition: 0.3s all ease-in-out;
  height: 50px;

  li {
    display: inline-flex;
    font-family: 'Helvetica Neue', -apple-system, BlinkMacSystemFont, 'Segoe UI',
      Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', sans-serif;
    font-size: 14px;
    font-weight: 500;
    margin: 0 24px 0 0;
    text-transform: uppercase;
  }

  li: hover {
    cursor: pointer;
  }

  li a {
    color: white;
  }
`;

const PreHeaderButton = styled.a`
  height: 50px;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  border: 0;
  font-family: 'CG-bold', sans-serif;
  text-transform: uppercase;
  font-size: 16px;
  padding: 0 32px;
  outline: none;
  color: white;
  font-weight: bold;
  transition: 0.3s all ease-in-out;

  background-color: ${({ type }) =>
    type === 'primary' ? '#ED1B2E' : '#2F5DB4'};

  &:hover {
    color: #fff;
    background-color: ${({ type }) =>
      type === 'primary' ? '#9A0B0B' : '#003366'};
  }
`;

const MainHeader = styled.div<{
  removeNavLinks?: boolean;
  mobileLogo?: boolean;
}>`
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: justify;
  -ms-flex-pack: justify;
  ${({ removeNavLinks, mobileLogo }) =>
    removeNavLinks && !mobileLogo
      ? 'justify-content: flex-end;'
      : 'justify-content: space-between;'}
  width: 100%;
  height: 90px;
  ${({ mobileLogo }) =>
    !mobileLogo ? `padding-left: 152px;` : `padding-left: 16px;`}

  .ant-menu-horizontal > .ant-menu-item {
    height: 100%;
    line-height: 90px;
    font-size: 16px;
    font-weight: 500;
  }
`;

const TSTMainHeader = styled.div`
  display: flex;
  height: 90px;
  width: 100%;
  justify-content: space-between;
  padding: 0 16px;

  .ant-menu-horizontal > .ant-menu-item {
    height: 100%;
    line-height: 90px;
    font-size: 16px;
    font-weight: 500;
  }

  @media screen and (max-width: 675px) {
  }
`;

const SubMenuItemLink = styled.li`
  padding: 4px 0;
  cursor: pointer;
  margin-bottom: 4px;

  a {
    color: #2f2f2f;
    font-size: 16px;

    &:hover {
      color: #00529b;
    }
  }
`;

const SubMenuPromotion = styled(Col)`
  display: -webkit-inline-box;
  display: -ms-inline-flexbox;
  display: inline-flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -ms-flex-flow: column wrap;
  flex-flow: column wrap;
  -webkit-box-align: start;
  -ms-flex-align: start;
  align-items: flex-start;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
  border-left: 1px solid #efefef;
  padding-left: 32px !important;
`;

const SubMenuPromotionTitle = styled.span`
  margin: 0 0 0 16px;
  font-size: 1.5rem;
  line-height: 1.2;
  color: #2f2f2f;
  font-weight: 900;
  display: block;
  margin: 0 0 16px;
`;

const MainHeaderRightIcons = styled.div`
  height: 100%;
  display: flex;
  align-items: center;
  flex-flow: row nowrap;

  .anticon {
    width: 60px;
    height: 60px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 50%;
    cursor: pointer;
    transition: 0.3s background-color ease-in-out;
    color: #000000d9;
  }
  .anticon:hover {
    background-color: #eee;
  }
  .anticon svg {
    width: 2em;
    height: 2em;
    font-weight: 700;
  }
`;

const MobileMenuButton = styled.div`
  color: white;
  height: 50px;
  min-width: 50px;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  font-size: 22px;
  background-color: #000;
`;

const CTAHeaderButtons = styled.div`
  display: inline-flex;
  justify-content: flex-end;

  ${({ fullwidth }) => (fullwidth ? 'width: 100%;' : null)}
`;

const MobileAAALogo = styled.div`
  display: flex;
  align-items: center;
`;

const SearchModal = styled(Modal)`
  .ant-modal-body {
    box-sizing: border-box;
  }
`;

const SearchInput = styled.input`
  width: 100%;
  height: 40px;
  border: 2px solid #ddd;
  border-radius: 4px;
  padding: 0 12px;

  font-size: 16px;
`;

const SearchItem = styled.div`
  padding: 12px 24px;

  &:hover {
    background-color: #99999920;
  }

  a {
    color: #333;
  }
  .search-body {
    color: #999;
  }
  em {
    background-color: #1a336320;
    color: #000;
    padding: 4px 6px;
    border-radius: 4px;
  }
`;

const AlertContainer = styled.div`
  background-color: #ed1b2e;
  position: relative;
  z-index: 1000;

  .ant-alert-warning {
    border: none;
    background-color: #ed1b2e;
    .ant-alert-message {
      color: white;
      display: block;
      margin-right: 32px;
      padding-right: 32px;
      line-height: 1.2;
    }
  }

  .ant-alert-close-icon .anticon-close {
    color: white;
    font-size: 1.2em;
    height: 16px;
  }
  .ant-alert-close-icon:before {
    content: 'close';
    color: white;
    font-size: 1.2em;
    top: -2px;
    margin-right: 4px;
    position: relative;
  }
`;

function navigate(path: string) {
  window.location.href = path;
}

const Header: React.FC<{ tmic?: boolean; uic?: boolean; TST?: boolean }> = ({
  tmic = false,
  uic = false,
  TST = false,
}) => {
  const { setSetting, settings } = useContext(SettingContext);
  const [current, setCurrent] = useState('');
  const [searchVisible, setSearchVisible] = useState(false);
  const [mobileCurrent, setMobileCurrent] = useState('');
  const [navTitle, setNavTitle] = useState('');
  const [overMenu, setOverMenu] = useState<string | null>(null);

  const [visibleMobileNav, setVisibleMobileNav] = useState(false);
  const [visibleMobile2ndNav, setVisibleMobile2ndNav] = useState(false);

  const toggleSearch = () => {
    setSearchVisible((visible) => !visible);
  };

  const handleMenuClick = (e: any) => {
    setCurrent(e.key);
  };

  const handleMenuItemClick = (url: string) => () => {
    window.location.href = url;
  };

  const handleMobileMenuClick = (e: any) => {
    setMobileCurrent(e.key);
    setNavTitle(e.label);
    showMobile2ndNavDrawer();
  };

  const minTabletView = useMedia(
    [device.laptopM, device.mobileL],
    [true, false],
    false
  );

  const showLogoTag = useMedia([`(min-width: 675px)`], [true], false);
  const showERSButton = useMedia([`(min-width: 623px)`], [true], false);
  const mobileDevice = useMedia([`(max-width: 550px)`], [true], false);

  const TSTMobileNav = useMedia([`(min-width: 1020px)`], [true], false);

  const showMobileNavDrawer = () => setVisibleMobileNav(true);
  const onCloseMobileNav = () => setVisibleMobileNav(false);
  const showMobile2ndNavDrawer = () => setVisibleMobile2ndNav(true);
  const onCloseMobile2ndNav = () => setVisibleMobile2ndNav(false);

  const showPreHeaderNavigation = useMedia(
    [device.laptopS, device.mobileL],
    [true, false],
    false
  );

  const mouseIn = (place: string | null) => () => {
    if (place) {
      setCurrent(place);
      setOverMenu(place);
    } else {
      setOverMenu(null);
    }
  };

  const goToMemberView = () => {
    setSetting('member', !settings.member);
  };

  const defaultBase = !tmic && !uic;

  const secondaryMobileNav = () => (
    <Drawer
      title={navTitle}
      placement="right"
      closable={true}
      onClose={onCloseMobile2ndNav}
      visible={visibleMobile2ndNav}
    >
      <Row>
        {menu
          .find((i) => i.key === mobileCurrent)
          ?.menu?.map((column, i) => (
            <Col key={i} xs={{ span: 24 }}>
              <ul
                style={{
                  paddingLeft: 0,
                  listStyle: 'none',
                  margin: 0,
                }}
              >
                {column.map((subMenuItem) => (
                  <SubMenuItemLink key={subMenuItem.key} style={{ margin: 0 }}>
                    <a href={subMenuItem.url}>{subMenuItem.label}</a>
                  </SubMenuItemLink>
                ))}
              </ul>
            </Col>
          ))}
      </Row>
    </Drawer>
  );

  const showMobileTag = !showLogoTag ? (
    <MobileAAALogo>
      <img
        src="https://aaacdndev.blob.core.windows.net/wordpress/icons/logo_AAA.png"
        style={{ width: 74 }}
      />
    </MobileAAALogo>
  ) : null;

  const displayAlert = (
    <AlertContainer>
      <Col xs={{ span: 21, offset: 1 }} md={{ span: 20, offset: 2 }}>
        {/* <Alert
          message="Please be advised the Join and Renew sites will be down on Sunday, February 14 from 1am - 7am for routine maintenance. Call 866-566-8635 if you need assistance."
          type="warning"
          showIcon
          closable
        /> */}
        {/* <Alert
          message="PLEASE NOTE: Access to all online Member Services systems will be unavailable for scheduled maintenance on Sunday, March 7 from 2 - 6 a.m. For immediate assistance, please call 800-477-4222."
          type="warning"
          showIcon
          closable
        /> */}
        {/* <Alert
          message="PLEASE NOTE: We're sorry our branch office phone systems are currently down, but should be up soon. We apologize for the inconvenience."
          type="warning"
          showIcon
          closable
        /> */}
        <Alert
          message="“System Maintenance. Our digital Insurance applications will be undergoing maintenance beginning on Friday, 4/21, at approx. 9 p.m., and lasting thru Sunday, 4/23. We apologize for the inconvenience and look forward to serving you soon."
          type="warning"
          showIcon
          closable
        />
      </Col>
    </AlertContainer>
  );

  return (
    <>
      {/* {displayAlert} */}
      <PreHeader>
        {showPreHeaderNavigation ? (
          <PreHeaderNavigation>
            {defaultBase ? (
              <>
                <li>
                  <a href="https://living.acg.aaa.com/">AAA Living</a>
                </li>
                <li>
                  <a href="https://carolinas.aaa.com/about/careers/">Careers</a>
                </li>
                <li id="contact-aaa">
                  <a href="https://carolinas.aaa.com/about/contact-us/">
                    Contact
                  </a>
                </li>
              </>
            ) : null}

            {tmic ? (
              <li>
                <a href="tel:1-877-820-8642">1-877-820-8642</a>
              </li>
            ) : null}

            {uic ? (
              <li>
                <a href="tel:1-800-258-0143">1-800-258-0143</a>
              </li>
            ) : null}
          </PreHeaderNavigation>
        ) : null}

        {mobileDevice ? (
          <CTAHeaderButtons fullwidth={!showLogoTag}>
            <PreHeaderButton
              href="https://join.carolinas.aaa.com/?promo=INTRNET"
              role="button"
              className="ctaJoin"
              type="primary"
              style={{ width: '30%', padding: '0 16px', fontSize: 14 }}
            >
              Join
            </PreHeaderButton>
            {tmic ? null : (
              <PreHeaderButton
                href="https://carolinas.aaa.com/membership/renew/"
                id="renew-membership-btn"
                role="button"
                className="ctaRenew"
                style={{ width: '70%', padding: '0 16px', fontSize: 14 }}
              >
                Renew Membership
              </PreHeaderButton>
            )}
          </CTAHeaderButtons>
        ) : (
          <CTAHeaderButtons fullwidth={!showLogoTag}>
            <PreHeaderButton
              href="https://join.carolinas.aaa.com/?promo=INTRNET"
              role="button"
              className="ctaJoin"
              type="primary"
              style={
                !showERSButton || !showLogoTag ? { width: '40%' } : undefined
              }
            >
              Join AAA
            </PreHeaderButton>
            {tmic ? null : (
              <PreHeaderButton
                href="https://carolinas.aaa.com/membership/renew/"
                id="renew-membership-btn"
                role="button"
                className="ctaRenew"
                style={
                  !showERSButton || !showLogoTag ? { width: '60%' } : undefined
                }
              >
                Renew Membership
              </PreHeaderButton>
            )}
          </CTAHeaderButtons>
        )}

        {showERSButton && !tmic && !TST ? (
          <PreHeaderButton
            id="aaa-roadside-icon"
            href="https://roadside.acg.aaa.com/"
            role="button"
            style={{ backgroundColor: '#343434', padding: '0 24px' }}
          >
            <img
              src="https://aaacdndev.blob.core.windows.net/wordpress/icons/tow-truck-white%402x.png"
              style={{ width: 40 }}
            />
          </PreHeaderButton>
        ) : null}

        {!minTabletView && !TST ? (
          <MobileMenuButton onClick={showMobileNavDrawer}>
            <MenuOutlined onClick={(e) => e.preventDefault()} />
          </MobileMenuButton>
        ) : null}

        {TST ? (
          <PreHeaderButton
            id="aaa-roadside-icon"
            href="https://roadside.acg.aaa.com/"
            role="button"
            style={{ backgroundColor: '#343434', padding: '0 24px' }}
          >
            <img
              src="https://aaacdndev.blob.core.windows.net/wordpress/icons/tow-truck-white%402x.png"
              style={{ width: 40 }}
            />
          </PreHeaderButton>
        ) : null}
      </PreHeader>

      {showLogoTag && !TST ? (
        <TagLogo
          style={{ alignItems: 'flex-end', paddingBottom: 22, left: 32 }}
        />
      ) : null}

      {defaultBase && !TST ? (
        <MainHeader
          onMouseLeave={mouseIn(null)}
          mobileLogo={!showLogoTag}
          removeNavLinks={!minTabletView}
        >
          {minTabletView ? (
            <Menu
              onClick={handleMenuClick}
              defaultOpenKeys={['membership']}
              selectedKeys={[current]}
              mode="horizontal"
            >
              {menu.map((menuItem) => (
                <Menu.Item
                  key={menuItem.key}
                  onMouseEnter={mouseIn(menuItem.key)}
                  onClick={handleMenuItemClick(menuItem.url)}
                >
                  {menuItem.label}
                </Menu.Item>
              ))}
            </Menu>
          ) : null}

          {showMobileTag}

          {overMenu !== null ? (
            <div
              style={{
                position: 'absolute',
                zIndex: 10,
                width: '80%',
                background: 'white',
                padding: '16px 20px 8px',
                top: 140,
                minHeight: 60,
              }}
            >
              <Row gutter={[16, 16]} style={{ margin: '8px -8px 16px' }}>
                <Col flex="50%">
                  <Row>
                    {menu
                      .find((i) => i.key === overMenu)
                      ?.menu?.map((column, i) => (
                        <Col key={i} xs={{ span: 12 }}>
                          <ul
                            style={{
                              paddingLeft: 0,
                              listStyle: 'none',
                              margin: 0,
                            }}
                          >
                            {column.map((subMenuItem) => (
                              <SubMenuItemLink key={subMenuItem.key}>
                                <a href={subMenuItem.url}>
                                  {subMenuItem.label}
                                </a>
                              </SubMenuItemLink>
                            ))}
                          </ul>
                        </Col>
                      ))}
                  </Row>
                </Col>
                <SubMenuPromotion flex="50%">
                  {(menu.find((i) => i.key === overMenu)?.promo as any)?.map(
                    (item: any) => (
                      <>
                        <SubMenuPromotionTitle>
                          {item.title}
                        </SubMenuPromotionTitle>
                        <p>{item.content}</p>
                        <a href={item.buttonUrl}>{item.buttonText}</a>
                      </>
                    )
                  ) || null}
                </SubMenuPromotion>
              </Row>
            </div>
          ) : null}

          <MainHeaderRightIcons>
            <a href="https://members.carolinas.aaa.com/LoginPage">
              <TeamOutlined onClick={goToMemberView} />
            </a>
            <a href="https://locator.carolinas.aaa.com/search">
              <PushpinOutlined />
            </a>
            <SearchOutlined onClick={toggleSearch} />
          </MainHeaderRightIcons>
        </MainHeader>
      ) : null}

      {defaultBase && TST ? (
        <>
          {TSTMobileNav ? (
            <TSTMainHeader>
              <MobileAAALogo>
                <img
                  src="https://aaacdndev.blob.core.windows.net/wordpress/icons/logo_AAA.png"
                  style={{ width: 74 }}
                />
              </MobileAAALogo>
              <Menu mode="horizontal">
                <Menu.Item>
                  <a href="https://carolinas.aaa.com/membership">Membership</a>
                </Menu.Item>
                <Menu.Item>
                  <a href="https://carolinas.aaa.com/travel">Travel & Maps</a>
                </Menu.Item>
                <Menu.Item>
                  <a href="https://carolinas.aaa.com/automotive">Automotive</a>
                </Menu.Item>
                <Menu.Item>
                  <a href="https://carolinas.aaa.com/insurance">Insurance</a>
                </Menu.Item>
                <Menu.Item>
                  <a href="https://carolinas.aaa.com/discounts">Discounts</a>
                </Menu.Item>
                <Menu.Item>
                  <a href="https://carolinas.aaa.com/financial">Financial</a>
                </Menu.Item>
                <Menu.Item>
                  <a href="https://carolinas.aaa.com/traffic-safety">
                    Traffic Safety
                  </a>
                </Menu.Item>
              </Menu>
            </TSTMainHeader>
          ) : (
            <TSTMainHeader>
              <MobileAAALogo>
                <img
                  src="https://aaacdndev.blob.core.windows.net/wordpress/icons/logo_AAA.png"
                  style={{ width: 74 }}
                />
              </MobileAAALogo>
              <Menu mode="horizontal">
                <Menu.Item>
                  <a href="https://carolinas.aaa.com/travel">Travel & Maps</a>
                </Menu.Item>
                <Menu.Item style={{ display: 'none' }}>
                  <a href="https://members.carolinas.aaa.com/LoginPage">
                    Members Portal
                  </a>
                </Menu.Item>
              </Menu>
            </TSTMainHeader>
          )}
        </>
      ) : null}

      {tmic ? (
        <MainHeader mobileLogo={!showLogoTag} removeNavLinks={!minTabletView}>
          {minTabletView ? (
            <Menu mode="horizontal">
              {menuTMIC.map((menuItem) => (
                <Menu.Item key={menuItem.key}>
                  <a href={menuItem.url}>{menuItem.label}</a>
                </Menu.Item>
              ))}
            </Menu>
          ) : null}
          {showMobileTag}
          <MainHeaderRightIcons>
            <PreHeaderButton
              style={{ marginRight: 16 }}
              href="https://carolinas.aaa.com/tmic/manage-policy"
            >
              Manage My Policy
            </PreHeaderButton>
          </MainHeaderRightIcons>
        </MainHeader>
      ) : null}

      {uic ? (
        <MainHeader mobileLogo={!showLogoTag} removeNavLinks={!minTabletView}>
          {minTabletView ? (
            <Menu mode="horizontal">
              <Menu.Item key="uic-logo">
                <img
                  src="https://carolinas.aaa.com/wp-content/themes/aaawpmigrate/img//insurance/uic/UIC.png"
                  style={{ width: 100 }}
                />
              </Menu.Item>
              {menuUIC.map((menuItem) => (
                <Menu.Item key={menuItem.key}>
                  <a href={menuItem.url}>{menuItem.label}</a>
                </Menu.Item>
              ))}
            </Menu>
          ) : null}
          {showMobileTag}
          <MainHeaderRightIcons>
            <PreHeaderButton
              style={{ marginRight: 16 }}
              href="https://carolinas.aaa.com/tmic/manage-policy"
            >
              Pay Online
            </PreHeaderButton>
          </MainHeaderRightIcons>
        </MainHeader>
      ) : null}

      <Drawer
        title={defaultBase ? 'Expect Something More' : 'AAA'}
        placement="right"
        closable={true}
        onClose={onCloseMobileNav}
        visible={visibleMobileNav}
      >
        {defaultBase ? (
          <>
            <div>
              {menu.map((menuItem) => (
                <div
                  key={menuItem.key}
                  onClick={() => handleMobileMenuClick(menuItem)}
                  style={{ fontWeight: 700, fontSize: 16 }}
                >
                  {menuItem.label}
                </div>
              ))}
            </div>

            <ul style={{ marginTop: 16, listStyle: 'none', padding: 0 }}>
              <li
                style={{
                  marginBottom: 16,
                  fontSize: 16,
                  fontWeight: 700,
                }}
              >
                <a
                  style={{ color: '#333' }}
                  href="https://roadside.acg.aaa.com/"
                >
                  Emergency Road Service
                </a>
              </li>

              <li>
                <a href="https://living.acg.aaa.com/">AAA Living</a>
              </li>
              <li>
                <a href="https://carolinas.aaa.com/about/careers/">Careers</a>
              </li>
              <li>
                <a href="https://carolinas.aaa.com/about/contact-us/">
                  Contact
                </a>
              </li>
            </ul>
          </>
        ) : null}

        {tmic ? (
          <div>
            {menuTMIC.map((menuItem) => (
              <div key={menuItem.key} style={{ fontWeight: 700, fontSize: 16 }}>
                <a href={menuItem.url} style={{ color: '#333' }}>
                  {menuItem.label}
                </a>
              </div>
            ))}
            <Button
              style={{ marginTop: 16, fontWeight: 700 }}
              href="tel:1-877-820-8642"
            >
              (877) 820-8642
            </Button>
          </div>
        ) : null}

        {uic ? (
          <div>
            {menuUIC.map((menuItem) => (
              <div key={menuItem.key} style={{ fontWeight: 700, fontSize: 16 }}>
                <a href={menuItem.url} style={{ color: '#333' }}>
                  {menuItem.label}
                </a>
              </div>
            ))}
            <Button
              style={{ marginTop: 16, fontWeight: 700 }}
              href="tel:1-800-258-0143"
            >
              (800) 258-0143
            </Button>
          </div>
        ) : null}

        {secondaryMobileNav()}
      </Drawer>

      <SearchModal
        title="How can we help?"
        visible={searchVisible}
        onCancel={toggleSearch}
        footer={null}
      >
        {/* <WithSearch
          mapContextToProps={(context) => ({
            ...context,
          })}
        >
          {({ searchTerm, setSearchTerm, results, ...rest }) => {
            console.log('results: ', results, rest);
            return (
              <div>
                <div style={{ padding: '0 24px' }}>
                  <SearchInput
                    value={searchTerm}
                    onChange={(e) => setSearchTerm(e.target.value)}
                    placeholder=""
                  />
                </div>
                {results.map((r) => (
                  <SearchItem key={r.id.raw}>
                    <a href={r.url.raw}>
                      <strong>{r.title.raw}</strong>
                      <div
                        className="search-body"
                        dangerouslySetInnerHTML={{ __html: r.sections.snippet }}
                      />
                    </a>
                  </SearchItem>
                ))}
              </div>
            );
          }}
        </WithSearch> */}

        <SearchBox
          autocompleteResults={{
            titleField: 'title',
            urlField: 'url',
          }}
          autocompleteSuggestions={true}
          onSubmit={(searchTerm) => {
            navigate('/search?q=' + searchTerm);
          }}
          onSelectAutocomplete={(
            selection,
            {},
            defaultOnSelectAutocomplete
          ) => {
            if (selection.suggestion) {
              navigate('/search?q=' + selection.suggestion);
            } else {
              defaultOnSelectAutocomplete(selection);
            }
          }}
        />
      </SearchModal>
    </>
  );
};

/* <div class="main-navigation row">
      <div class="logo-tag">
          <a href="https://carolinas.aaa.com/">
              <img src="https://aaacdndev.blob.core.windows.net/wordpress/icons/aaa-logo-white%402x.png" />
          </a>
      </div>
      <div class="main-navigation__links-container">
          <div class="search-container">
              <form role="search" method="get" class="search-container__input animated fadeIn search-form" action="https://carolinas.aaa.com/">
                  <input
                      type="text"
                      class="st-default-search-input site-search"
                      placeholder="Search AAA.com..."
                      value=""
                      name="s"
                  />
                  <button type="submit" class="search-container__button">Go</button>
              </form>
          </div>
          <div class="logo-mobile">
              <!-- <a href="https://carolinas.aaa.com/"><img src="https://aaacdndev.blob.core.windows.net/wordpress/icons/logo_AAA.png" /></a> -->
              <a href="https://carolinas.aaa.com/"><img src="https://aaacdndev.blob.core.windows.net/wordpress/2020/04/roofLogo_mobile.png" /></a>
          </div>
          <ul id="aaa-main-links" class="main-navigation__links animated fadeIn">
              <li id="membership-dropdown" class="main-navigation__link"><a href="https://carolinas.aaa.com/membership/">Membership</a></li>
              <li id="travel-dropdown" class="main-navigation__link"><a href="https://carolinas.aaa.com/travel/">Travel & Maps</a></li>
              <li id="automotive-dropdown" class="main-navigation__link"><a href="https://carolinas.aaa.com/automotive/">Automotive</a></li>
              <li id="insurance-dropdown" class="main-navigation__link"><a href="https://carolinas.aaa.com/insurance/">Insurance</a></li>
              <li id="discounts-dropdown" class="main-navigation__link"><a href="https://carolinas.aaa.com/discounts/">Discounts</a></li>
              <li id="financial-dropdown" class="main-navigation__link"><a href="https://carolinas.aaa.com/financial/">Financial</a></li>
              <li id="traffic-dropdown" class="main-navigation__link"><a href="https://carolinas.aaa.com/traffic-safety/">Traffic Safety</a></li>
          </ul>
          <ul class="main-navigation__icons">
              <li id="aaa-member-icon"><a href="https://members.carolinas.aaa.com/"><img src="https://aaacdndev.blob.core.windows.net/wordpress/icons/aaa-member.svg" /></a></li>
              <li id="aaa-locations-icon"><a href="https://locator.carolinas.aaa.com/search"><img src="https://aaacdndev.blob.core.windows.net/wordpress/icons/aaa-map-pin.svg" /></a></li>
              <li id="aaa-search-icon">
                  <img src="https://aaacdndev.blob.core.windows.net/wordpress/icons/aaa-search.svg" class="show-search-input" />
                  <img src="https://aaacdndev.blob.core.windows.net/wordpress/icons/close.png" class="close-search-input" />
              </li>
          </ul>
      </div>
      <div class="main-navigation__dropdown-container container">
          <div class="main-navigation__links-dropdown">
              <!-- dynamic menu content -->
          </div>
      </div>
  </div>

  <div class="mobilefs-navigation">
      <div class="mobilefs-navigation__title-container">
          <button class="mobilefs-navigation__back">Back</button>
          <h4>Menu Title</h4>
      </div>
      <div class="mobilefs-navigation__links-container">
          <ul id="aaa-mobile-links" class="mobile-navigation__links animated fadeIn">
              <li id="membership-mobile">Membership</li>
              <li id="travel-mobile">Travel & Maps</li>
              <li id="automotive-mobile">Automotive</li>
              <li id="insurance-mobile">Insurance</li>
              <li id="discounts-mobile">Discounts</li>
              <li id="financial-mobile">Financial</li>
              <li id="traffic-mobile">Traffic Safety</li>
          </ul>
          <ul id="aaa-mobile-footer-links" class="mobile-navigation__links secondary animated fadeIn">
              <li><a href="https://living.acg.aaa.com/">AAA Living</a></li>
              <li><a href="https://the-travel-store-aaa-carolinas.myshopify.com/">Travel Shop</a></li>
              <li><a href="https://carolinas.aaa.com/about/careers/">Careers</a></li>
              <li><a href="https://carolinas.aaa.com/about/contact-us/">Contact Us</a></li>
              <li><a href="https://carolinas.aaa.com/about/">About AAA</a></li>
          </ul>
      </div>
      <div class="mobilefs-navigation__links-secondary"></div>
  </div> */

export default Header;
